export const apiUrls = {
  auth: 'Authorize',
  blockCard: 'BlockCard',
  changeContacts: 'ChangeContacts',
  changePassword: 'ChangePassword',
  checkCode: 'CheckCode',
  completePoll: 'Polls',
  content: 'Content',
  createRequest: 'Requests',
  getAcceptorsList: 'ListAcceptors',
  getListLoyaltyPrograms: 'ListLoyaltyPrograms', // todo: когда будет понятно зачем - использовать
  getListAcceptorCategories: 'ListAcceptorCategories',
  getAcceptorBranches: 'AcceptorBranches',
  getActiveCertificates: 'ActiveCertificates',
  getECardInfo: 'eCardInfo',
  getApplications: 'Applications',
  getCertificatesHistory: 'CertificatesHistory',
  getCertificateInfo: 'Certificate/{id}/Info',
  getCertificateStatementExport: 'Certificate/{id}/Statement/Export',
  getExpenseLiabilities: '/IP/API/1_0/ListExpenseLiabilities', // todo: когда будет реализовано апи поменять
  getFAQ: 'FAQ',
  getFeedbackThemes: 'ListFeedbackThemes',
  getFile: 'Files/{id}',
  getAppealFile: 'RequestAttachmentFile/{id}',
  getResponseFile: 'RequestAnswerAttachmentFile/{id}',
  getLocalitiesList: 'ListLocalities',
  getNews: 'News',
  getNewsById: 'News/{id}',
  getNotifications: 'Notifications',
  getNotification: 'Notifications/{notificationId}',
  getPhoto: 'HolderPhoto',
  getPoll: 'Polls/{pollId}',
  getPolls: 'Polls',
  getPrivileges: 'AssignedSocHelp',
  getProfile: 'HolderProfile',
  getRequestById: 'Requests/{requestId}',
  getRequests: 'Requests',
  getSellers: 'SellersDepartmentsList',
  getDepartmentById: 'SellerDepartment/{id}',
  getSettings: 'ProfileSettings',
  // getStateAssignments: '/IP/API/1_0/ListStateAssignments', // todo: когда будет реализовано апи поменять
  // getStatePrograms: '/IP/API/1_0/ListStatePrograms', // todo: когда будет реализовано апи поменять
  login: 'Login/{login}',
  esiaGetLink: 'OAuthLink/Esia',
  esiaIssuePoints: 'IssuePoints',
  esiaLogin: 'Authorize/Esia',
  esiaLogout: 'LogoutLink/Esia',
  esiaRegistration: 'RegisterClient',
  esiaRegisterCardApplication: 'RegisterCardApplication',
  esiaActivateCard: 'ActivateCard',
  updateCardApplication: 'UpdateCardApplication',
  getCardTrackingInfo: 'CardTrackingInfo',
  newPass: 'SetPassword',
  readNotification: 'NotificationsStatusChange',
  sendCode: 'SendCode',
  sendCodeFromCabinet: 'SendCodeFromCabinet',
  sendCodeWithCheckPhone: 'SendCodeWithCheckPhone',
  setSettings: 'ProfileSettings',
  signOut: 'SignOut',
  updateFirebaseId: 'UpdateFirebaseId',
  changeRequestReadingStatus: 'ChangeRequestReadingStatus',
  getAgreementContent: 'Agreements/{name}',
  checkContactsUniqueness: 'checkContactsUniqueness',

  signOutDobroRu: 'SignOut/DobroRU',
  dobroruLink: 'OAuthLink/DobroRu',
  dobroruLogin: 'Authorize/DobroRu',
  volunteerEvents: 'VolunteerEvents',
  molodayaArcticaTransactions: 'GetTransactions',
  postTransferVolunteerScore: 'TransferVolunteerScore',

  setProductsByFilters: 'FilterMarketCatalog',
  getProductFiltersList: 'MarketFilterOptions',
  getMarketTransactionsHistory: 'MarketTransactionsHistory',
  getProductDetails: 'ProductDetails/{productId}',

  getLevelsInfo: 'VolunteerLevelOptions',
  postUnsubscribeSmsEmail: 'Unsubscribe',

  registerSkipassClient: 'Bars/RegisterClient',
  unregisterSkipassClient: 'Bars/RemoveCard',
  getSkipassClientInfo: 'Bars/ClientInfo',

  postProcessPrompt: 'ChatBot/ProcessPrompt',
  getChatHistory: 'ChatBot/ChatHistory',

  getAgreementById: 'SocialServiceRegistry/Agreements/{id}/Document',
  getAgreements: 'SocialServiceRegistry/Agreements',

  getActById: 'SocialServiceRegistry/Acts/{id}/Document',
  getActs: 'SocialServiceRegistry/Acts',
};
